import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import { doObjToFormData } from "../../helpers/helpers";
import http from "../../helpers/http";
import httpos from "../../helpers/httpos";

export default function DeletePropertyLabel({ label_id,setIsDeleting }) {
  //   console.log(label_id);
  

  const onHandleLAbelDelete = (e) => {
    e.preventDefault();
    if (label_id) {
      setIsDeleting(true);
      httpos
        .post(`delete-property-label`, doObjToFormData({ label_id }))
        .then(({ data }) => {
          setIsDeleting(false);
          if (data.status) {
            document.getElementById("label_" + label_id).remove();
            toast.success(data?.msg, TOAST_SETTINGS);
          } else {
            toast.error(data?.msg, TOAST_SETTINGS);
          }
        })
        .catch((error) => {
          setIsDeleting(false);
        });
    } else {
      toast.error("Invalid Label!", TOAST_SETTINGS);
      return;
    }
  };
  return (
    <>
      {/* <ToastContainer /> */}
      <div className="crosBtn" onClick={onHandleLAbelDelete}>
        x
      </div>
    </>
  );
}
